import { render, staticRenderFns } from "./CampaignPreview.vue?vue&type=template&id=4fcbef8d&"
import script from "./CampaignPreview.vue?vue&type=script&lang=js&"
export * from "./CampaignPreview.vue?vue&type=script&lang=js&"
import style0 from "./CampaignPreview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports